import React from 'react';
import { useEffect } from 'react';
import useFeatureFlags from "../../hooks/useFeatureFlags";
import { Box, CircularProgress } from '@mui/material';
import { useDispatch } from "react-redux";
import { setUseMockResponseState } from '../../redux/suggestions';


export const CenteredProgress = () => (
  <Box>
    <CircularProgress color="primary" data-testid={'circular-progress'} />
  </Box>
);

export const PutLDFlagIntoState = ({ children }: { readonly children: JSX.Element }) => {
  const dispatch = useDispatch();
  const { getFlag } = useFeatureFlags();
  const useMockAnalysisResponse = getFlag('shouldUseMockAnalysisResponse');

  useEffect(() => {
    dispatch(setUseMockResponseState(useMockAnalysisResponse));
  }, [dispatch, useMockAnalysisResponse]);

  return children;
};
